export const queryUAParser = (key: string):string => {
  const ua = window.navigator.userAgent;
  const arr: { [key: string]: string } = {};
  ua.replace(
    /\??(\w+)=(\w+)&?/g,
    (match, matchKey: string, matchValue: string): string => (arr[matchKey as string] = matchValue),
  );
  return arr[key] || '';
};
